import './App.css';
import React from 'react';
import { ContentBlock } from './types';

interface ContentBlockProps {
  block: ContentBlock;
}

function ContentBlockComponent({ block }: ContentBlockProps): React.JSX.Element {
  switch (block.type) {
    case 'paragraph':
      return <p className="content-block-paragraph">{block.content}</p>;
    
    case 'heading':
      const HeadingTag = `h${block.level}` as 'h1' | 'h2' | 'h3';
      return <HeadingTag className={`content-block-heading content-block-heading-${block.level}`}>{block.content}</HeadingTag>;
    
    case 'code':
      return (
        <div className="content-block-code">
          {block.language && <div className="content-block-code-language">{block.language}</div>}
          <pre><code>{block.code}</code></pre>
        </div>
      );
    
    case 'image':
      return (
        <figure className="content-block-image">
          <img src={block.src} alt={block.alt} />
          {block.caption && <figcaption className="content-block-image-caption">{block.caption}</figcaption>}
        </figure>
      );
    
    case 'list':
      const ListTag = block.ordered ? 'ol' : 'ul';
      return (
        <ListTag className="content-block-list">
          {block.items.map((item, index) => (
            <li key={index} className="content-block-list-item">{item}</li>
          ))}
        </ListTag>
      );
    
    case 'quote':
      return (
        <blockquote className="content-block-quote">
          <p className="content-block-quote-text">{block.content}</p>
          {block.author && <cite className="content-block-quote-author">— {block.author}</cite>}
        </blockquote>
      );
    
    default:
      return <></>;
  }
}

export default ContentBlockComponent;

